
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCellular = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 1201 1200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M805.792 138.462H394.258c-34.285 0-62.347 28.035-62.347 62.347v798.356c0 34.315 28.062 62.375 62.347 62.375h411.534c34.286 0 62.348-28.01 62.348-62.348V200.809c0-34.312-28.062-62.347-62.348-62.347zm-271.595 44.941h131.657c4.167 0 7.543 3.375 7.543 7.569a7.542 7.542 0 0 1-7.543 7.543H534.197a7.542 7.542 0 0 1-7.543-7.543c0-4.194 3.376-7.569 7.543-7.569zm65.828 846.967c-17.222 0-31.173-13.96-31.173-31.205 0-17.248 13.951-31.173 31.173-31.173 17.222 0 31.174 13.925 31.174 31.173 0 17.245-13.952 31.205-31.174 31.205zm224.73-84.216H375.296V237.337h449.459v708.817z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 1201 1200\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path d=\"M805.792 138.462H394.258c-34.285 0-62.347 28.035-62.347 62.347v798.356c0 34.315 28.062 62.375 62.347 62.375h411.534c34.286 0 62.348-28.01 62.348-62.348V200.809c0-34.312-28.062-62.347-62.348-62.347zm-271.595 44.941h131.657c4.167 0 7.543 3.375 7.543 7.569a7.542 7.542 0 0 1-7.543 7.543H534.197a7.542 7.542 0 0 1-7.543-7.543c0-4.194 3.376-7.569 7.543-7.569zm65.828 846.967c-17.222 0-31.173-13.96-31.173-31.205 0-17.248 13.951-31.173 31.173-31.173 17.222 0 31.174 13.925 31.174 31.173 0 17.245-13.952 31.205-31.174 31.205zm224.73-84.216H375.296V237.337h449.459v708.817z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n  <defs>\r\n    <style xmlns=\"http://www.w3.org/2000/svg\" type=\"text/css\">\r\n\r\n    </style>\r\n  </defs>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/cellular.18f036f03998c50064bc125d10f57098.svg"),
        {
          React: SvgCellular,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      